
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schedule-call",
      function () {
        return require("private-next-pages/schedule-call/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schedule-call"])
      });
    }
  